/**
 * Позиции доступные для показа промо.
 * Сравниваются со счетчиком голосов.
 */
export const promoPositions = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]

export const promoIntervalEnd = promoPositions[promoPositions.length - 1]

export enum RatingPromo {
  featured = 'featured',
  banner = 'banner',
  incognito = 'incognito',
}

export enum RatingItemType {
  promo = 'promo',
  photo = 'photo',
}
